module.exports = __webpack_public_path__ + "img/mfd_in_1_txt.deeee53f.png";